import { AgGridReact } from "ag-grid-react";
import { useRef } from "react";
import useBranchColumnDefs from "../../Setting/Branch/useBranchColumnDefs";
import { ColDef, ICellRendererParams } from "ag-grid-community";
import AgGrid from "../../../UI/AgGrid";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useDisable } from "../../../../hooks/use-disable";

type Props = {
  rowData: any[];
  lockRows?: string[];
  onRemoveHandler: (index: number) => void;
};

const PreOrderQuotaSettingBranchTable = ({
  rowData,
  lockRows,
  onRemoveHandler,
}: Props) => {
  const gridRef = useRef<AgGridReact>();
  const columnDefs: ColDef[] = useBranchColumnDefs({ isPreOrderQuota: true });
  const [disabled] = useDisable();

  const formatColumnDef: ColDef[] = [
    ...columnDefs,
    ...(disabled
      ? []
      : [
          {
            field: "",
            filter: false,
            sortable: false,
            width: 50,
            cellStyle: {
              display: "flex",
              justifyContent: "center",
            },
            cellRenderer: (params: ICellRendererParams) => {
              if (lockRows?.includes(params.data?.unique_id)) return null;
              if (params.data) {
                return (
                  <IconButton
                    onClick={() => onRemoveHandler(params.data?.index)}
                    size="small"
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                );
              }
            },
          },
        ]),
  ];

  return (
    <AgGrid
      ref={gridRef}
      columnDefs={formatColumnDef}
      rowData={rowData}
      height={300}
    />
  );
};

export default PreOrderQuotaSettingBranchTable;
